<template>
    <div class="vcwrapie">
        此浏览器不支持摄像头调用，建议使用CHROME浏览器。
    </div>

</template>

<script>
    export default {
        name: "Crecordervideoie"
    };
</script>

<style scoped>
    .vcwrapie { width: 100%; height: 100%; display: block; text-align: center; font-size: 12px; line-height: 24px; padding: 20px; }
</style>
